import React from 'react';
import styles from '../FloatingLabel.module.css';
import MultiSelect, { ISelectOption } from '../../MultiSelect/MultiSelect';

type FloatingLabelMultiSelectProps = {
    availableOptions: ISelectOption[];
    selectedOptions: ISelectOption[];
    onChange: (selectedOptions: ISelectOption[]) => void;
    label: string;
    required?: boolean;
};

const FloatingLabelMultiSelect = ({ availableOptions, selectedOptions, onChange, label, required }: FloatingLabelMultiSelectProps) => {

  return (
    <div className={styles.floatingLabelSelector}>
      <label className={styles.floatingLabel}>
        {label}
        {required && <span className={styles.asterisk}>*</span>}
      </label>
      <MultiSelect availableOptions={availableOptions} selectedOptions={selectedOptions} onChange={onChange}/>
    </div>
  );
};

export default FloatingLabelMultiSelect;